// extracted by mini-css-extract-plugin
export var searchHeader = "_9b-0";
export var searchHeaderDark = "_9b-1";